var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRabbitmq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7316 13.6922C27.5029 13.4647 27.1935 13.337 26.871 13.337L26.872 13.336H19.348C18.746 13.264 18.288 12.734 18.288 12.11V4.214C18.288 3.54 17.741 3 17.073 3H14.44C13.766 3 13.226 3.546 13.226 4.214V12.194C13.193 12.796 12.696 13.282 12.099 13.337H10.129C9.84646 13.2994 9.58574 13.1648 9.39133 12.9564C9.19692 12.7479 9.08088 12.4785 9.063 12.194V4.215C9.063 3.541 8.517 3.001 7.849 3.001H5.216C4.541 3.001 4 3.547 4 4.215V27.256C4 27.5782 4.12801 27.8873 4.35587 28.1151C4.58372 28.343 4.89276 28.471 5.215 28.471H26.877C27.55 28.471 28.091 27.925 28.091 27.256V14.551C28.0894 14.2285 27.9602 13.9197 27.7316 13.6922Z",
    fill: "#FF6600"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 5,
    height: 5,
    rx: 1,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbitmq);
export default __webpack_public_path__ + "static/media/rabbitmq.166edb0166f6fa2e68ebd8db2d62fe09.svg";
export { ForwardRef as ReactComponent };